import styled, { css } from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow-y: auto;

    @media only screen and (max-width: 959px) {
        margin-inline: -36px;
    }

    @media only screen and (max-width: 600px) {
        gap: 24px;
    }
`

export const CloseButton = styled.button`
    align-items: center;
    background-color: var(--primary);
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    height: 32px;
    justify-content: center;
    padding: 4px;
    position: absolute;
    right: 32px;
    transition: all 0.3s ease-in-out;
    top: 32px;
    width: 32px;

    @media only screen and (max-width: 600px) {
        height: 22px;
        width: 22px;
    }

    &:hover {
        background-color: var(--green-neon);
        transition: all 0.3s ease-in-out;
    }

    img {
        width: 60%;
    }
`

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;

    & > h1 {
        color: var(--black);
        font-size: 1.25rem;
        width: calc(100% - 32px);
    }

    @media only screen and (max-width: 959px) {
        padding-inline: 36px;
    }

`

export const Filter = styled.div`
    display: flex;
    gap: 16px;

    & > div {
        max-width: 312px;
    }

    @media only screen and (max-width: 959px) {
        gap: 12px;
        flex-direction: column;

        & > div {
            margin-bottom: 0;
            max-width: none;
        }
    }
`

export const Table = styled.table`
    border-collapse: separate;
    border-spacing: 0;
    caption-side: bottom;
    overflow: hidden;
    width: 100%;

    & > thead {
        background-color: #028350;
        border: 1px solid #028350;
        color: var(--white);
    }

    & > thead,
    & > tbody {
        & > tr {
            & > td {
                font-size: 0.875rem;
                padding: 12px 32px;
            }
        }
    }

    & > thead {
        & > tr {
            & > td {
                &:not(:first-of-type):not(:last-of-type) {
                    border-inline: 1px solid #88A8A4;
                }

                &:first-of-type {
                    border-top-left-radius: 16px;
                }

                &:last-of-type {
                    border-top-right-radius: 16px;
                }
            }
        }
    }

    & > tbody {
        overflow: hidden;
        color: #2D473E;

        & > tr {
            overflow: hidden;

            & > td {
                border: 1px solid #88A8A4;

                & > div {
                    align-items: center;
                    display: flex;
                    gap: 8px;
                    justify-content: space-between;
                }
            }

            &:last-of-type {
                & > td {
                    &:first-of-type {
                        border-bottom-left-radius: 16px;
                    }

                    &:last-of-type {
                        border-bottom-right-radius: 16px;
                    }
                }
            }
        }
    }

    @media only screen and (max-width: 959px) {
        display: none;
    }
`

export const Caption = styled.caption`
    color: #88A8A4;
    font-size: 0.75rem;
    padding-top: 16px;
    text-align: left;

    @media only screen and (max-width: 959px) {
        padding: 0;
        text-align: center;
    }
`

export const DesktopContainer = styled.div`
    @media only screen and (max-width: 959px) {
        display: none;
    }
`

export const MobileContainer = styled.div`
    @media only screen and (min-width: 960px) {
        display: none;
    }
`

export const MobileContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding-inline: 36px;
`

export const MobileItemsContainer = styled.div`
    background-color: #EBF3EF;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 24px 36px 28px;
    margin-inline: -36px;
`

export const MobileItem = styled.div`
    background-color: var(--white);
    border: 1px solid #88A8A4;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 16px 24px;

    & > p {
        color: #2D473E;
        font-size: 0.875rem;

        & > strong {
            color: #008350;
        }
    }
`

export const DetailsToggle = styled.button<{ $open: boolean }>`
    ${({ $open }) => css`
        background-color: ${$open ? '#008350' : 'transparent'};
        color: ${$open ? '#FFF' : '#008350'};
    `}

    border: 1px solid #008350;
    border-radius: 28px;
    font-size: 0.625rem;
    font-weight: 700;
    padding: 4px 0;
    width: 106px;
`

export const NestedTableWrapper = styled.tr`
    & > td {
        background-color: #EBF3EF;
        border-color: transparent;
        padding: 24px 32px !important;

        & > table {
            border-collapse: collapse;
            width: 100%;

            & > thead {
                & > tr {
                    background-color: #2D473E;

                    & > th {
                        color: #FFF;
                        padding: 8px 32px;
                        text-align: start;
                    }
                }
            }

            & > tbody {
                & > tr {
                    & > td {
                        background-color: #FFF;
                        padding: 12px 32px;

                        &:first-of-type {
                            width: 100%;
                        }

                        &:not(:first-of-type) {
                            text-align: center;
                        }
                    }
                }
            }
        }
    }
`

export const MobileDetailsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    & > hr {
        border-top: 1px solid #88A8A4;
        margin-left: -24px;
        width: calc(100% + 48px);

        &:last-of-type {
            display: none;
        }
    }

    & > div {
        display: flex;
        flex-direction: column;
        gap: 8px;

        strong,
        li {
            color: #2D473E;
            font-size: 0.75rem;
        }

        & > ul {
            list-style: none;
        }
    }
`
